import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'antd';

import withRole from 'components/common/withRole';
import Menu from 'components/common/Menu';
import ListTable from 'components/common/ListTable';
import { productMenuItems } from 'menus';
import { getProductCategories } from 'actions/asyncActions';
import { openProductCategoryModal } from 'actions/modalActions';
import CategoryFilter from 'filters/CategoryFilter';
import { PlusOutlined } from '@ant-design/icons';
import { DELETE_PRODUCT_CATEGORY, POST_PRODUCT_CATEGORY, PUT_PRODUCT_CATEGORY } from 'constants/actionTypes';

@withRole
@connect(null, { openProductCategoryModal })
export default class Categories extends Component {
    getColumns = isAdmin => [
        {
            title: 'Название',
            dataIndex: 'name',
            key: 'category',
            render: (text, item) => isAdmin ? (
                <span className='span-link' onClick={() => this.props.openProductCategoryModal(item)}>{text}</span>
            ) : (
                text
            ),
        }, {
            title: 'Группа',
            dataIndex: ['_embedded', 'productGroup', 'name'],
            key: 'group'
        }, {
            title: 'Департамент',
            dataIndex: ['_embedded', 'productDepartment', 'name'],
            key: 'department'
        }
    ];

    getMenuControls() {
        const { openProductCategoryModal, isAdmin } = this.props;

        return (
            <div>
                { isAdmin && (
                    <Button type='primary' icon={<PlusOutlined />} onClick={() => openProductCategoryModal()}>Создать</Button>
                )}
            </div>
        );
    }

    render() {
        const { isAdmin } = this.props;

        return (
            <div>
                <Menu
                    items={productMenuItems}
                    controls={this.getMenuControls()} />
                <ListTable
                    tableColumns={this.getColumns(isAdmin)}
                    action={getProductCategories}
                    filterForm={CategoryFilter}
                    refreshActions={[POST_PRODUCT_CATEGORY, PUT_PRODUCT_CATEGORY, DELETE_PRODUCT_CATEGORY]} />
            </div>
        );
    }
}
